import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useState } from "react";
import { QuestionnaireAPI } from "../../../../../../services/api";

const ToiletBrake = () => {
  const [open, setOpen] = useState(false);
  const [showText, setShowText] = useState(false);

  const handleToiletClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleToiletConfirm = async () => {
    await QuestionnaireAPI.requestPause();
    setOpen(false);
  };

  const handleMouseEnter = () => {
    setShowText(true);
  };

  const handleMouseLeave = () => {
    setShowText(false);
  };

  return (
    <>
      <div
        style={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button
          onClick={handleToiletClick}
          className="toilet-button"
          style={{ fontSize: "2em", backgroundColor: "#333" }}
        >
          🚽
        </button>
        {showText && (
          <div
            style={{
              position: 'absolute',
              top: '30px', // Adjust this value to move the text box relative to the button
              left: '50%',
              transform: 'translateX(-50%)',
              padding: '3px',
              backgroundColor: '#fff',
              border: '1px solid #333',
              borderRadius: '4px',
              color: '#000',
              fontSize: '0.8em',
            }}
          >
            שירותים
          </div>
        )}
      </div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{`?רוצה לבקש ללכת לשירותים`}</DialogTitle>

        <DialogActions>
          <Button onClick={handleToiletConfirm} color="primary">
            כן
          </Button>
          <Button onClick={handleClose} color="primary">
            לא
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export { ToiletBrake };
